import { NgModule } from '@angular/core';
import { PatientSearchModule } from './search/patient-search.module';
import { PatientOrderModule } from './order/patient-order.module';
import { PatientStatusModule } from './status/patient-status.module';

@NgModule({
    imports: [
        PatientSearchModule, PatientOrderModule, PatientStatusModule
    ],
    exports: [
        PatientSearchModule, PatientOrderModule, PatientStatusModule
    ],
})
export class PatientFilterModule { }
